var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.trend)?_c('div',{staticClass:"trend-container"},[_c('div',{class:['trend-badge', `trend-${_vm.trend.trend}`]},[_c('span',{staticClass:"direction"},[_vm._v(_vm._s(_vm.trend.direction))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.trend.value))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.trendLabel)+" (7 días)")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }